









































import { safeJsonParse } from '@/utils/safe-json-parse';
import Vue, { PropType } from 'vue';

export default Vue.extend({
    filters: {
        showQuestionType(val) {
            const map = new Map([[1, '单选题'], [2, '多选题'], [3, '判断题']]);
            const type = map.get(val) ? `(${map.get(val)})` : '';
            return type;
        }
    },
    props: {
        idx: Number,
        item: { type: Object as PropType<{ id: string; name: string; viewSettings: string; classType: number; standAnswerArray: string; remark: string }> },
        showHint: { type: Boolean as PropType<boolean> }
    },
    data() {
        return {
            selected: [] as string[],
            answer: '' as string
        };
    },
    computed: {
        isMulti(): boolean {
            return this.item.classType === 2;
        },
        isJudge(): boolean {
            return this.item.classType === 3;
        },
        didWrong(): boolean {
            if (!this.showHint) return false;
            const standarAnswer = this.getStandarAnswer(this.item.standAnswerArray);
            const selectedAnswer = this.answer;
            if (standarAnswer === selectedAnswer) {
                return false;
            }
            return true;
        }
    },
    methods: {
        getStandarAnswer(val) {
            const res = safeJsonParse(val);
            if (this.isJudge) {
                return res[0] === 'judgementTrue' ? '正确' : '错误';
            }

            return res.sort((a, b) => a.localeCompare(b)).join('');
        },
        handleSelectOption(value) {
            if (this.showHint) {
                return;
            }
            if (this.isMulti) {
                if (!this.selected.includes(value)) {
                    this.selected.push(value);
                } else {
                    this.selected.splice(this.selected.findIndex(v => v === value), 1);
                }
            } else {
                this.selected = [value];
            }

            // {id: string;selected: string[]}
            this.$emit('select', { id: this.item.id, selected: this.selected });
        },
        getOption(val): { value: string; label: string }[] {
            return safeJsonParse(val);
        }
    },
    watch: {
        selected: {
            handler(val) {
                if (this.isJudge) {
                    const res = val?.[0];
                    if (res === 'judgementTrue') {
                        this.answer = '正确';
                    } else {
                        this.answer = '错误';
                    }
                } else {
                    const temp = [...val];
                    this.answer = temp.sort((a, b) => a.localeCompare(b)).join('');
                }
            },
            deep: true
        }
    }
});
